import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function siteReducer(state: any = initialState.site, action: any) {
    switch (action.type) {
        case types.LOAD_SITE_CONSTANTS: {
            return action.site;
        }
        default:
            return state;
    }
}

export const getSite = (state) => state.site;
